// UserStatsModal.jsx
import React, { useEffect, useMemo, useState } from "react";
import { Icon, Modal, Spin } from "antd";
import moment from "moment";
import axios from "axios";
import { GET_FS_ADMIN_DASHBOARD_APPOINTMENT_STATS, GET_FS_ADMIN_USER_STATS, GET_FS_CALL_ACTION_STATS, GET_RS_ADMIN_USER_STATS, GET_RS_APPOINTMENT_STATS, GET_RS_OTHER_STATISTICS_PIE, GET_RS_OTHER_STATISTICS_PIE_1, GET_SUB_TYPE_OF_CALL_STATS, GET_TYPE_OF_CALL_STATS } from "../../../../utils/Api_enums";
import { BOBADMIN, EA, REVIEWADMIN, REVIEWSCHEDULER, VONBOARDER } from "../../../../utils/Constants";
import { useBoundStore } from "../../../../store/useBoundStore";




const UserStatsModal = ({ visible, onClose, userData, onCardClick }) => {
    const { resetRSFSCardFilters, RSFSCardFilters, setRSFSCardFilters, RSFSFilters } = useBoundStore();
    const [loading, setLoading] = useState(true);
    const [callCounts, setCallCounts] = useState([]);



    const DEFAULT_USER_DATA = (() => {
        const cardRaw = localStorage.getItem('card');
        const buckets = JSON.parse(localStorage.getItem('buckets'));
        if (!cardRaw) return null;

        const card = JSON.parse(cardRaw);
        return {
            id: card.user_id,
            name: card.userName,
            userType: card.role === REVIEWSCHEDULER ? REVIEWADMIN : VONBOARDER,
            start_date: card.start_date,
            end_date: card.end_date,
            data: buckets
        };
    })();


    const iconMeta = {
        'last_login': { icon: 'user', color: '#1890ff' },
        'upcoming_calls': { icon: 'calendar', color: '#FF9E3D' },
        'due_calls': { icon: 'clock-circle', color: '#F56C6C' },
        'total_appointments': { icon: 'phone', color: '#52C41A' },
        'FollowUp': { icon: 'message', color: '#FAAD14' },
        'Prospect': { icon: 'user', color: '#4096FF' },
        'Thank You / Referrals': { icon: 'smile', color: '#722ED1' },
        'Life Insurance': { icon: 'insurance', color: '#13C2C2' },
        'Cross-Sell': { icon: 'swap', color: '#2F54EB' },
        'Commercial': { icon: 'shop', color: '#EB2F96' },
        'Retirement': { icon: 'money-collect', color: '#52C41A' },
        'total_non_responsive': { icon: 'warning', color: '#FF4D4F' },
        'reschedule_appointments': { icon: 'schedule', color: '#FFA500' },
        'total_not_interested': { icon: 'frown', color: '#FF4D4F' },
        'bad_phone_number': { icon: 'disconnect', color: '#FF4D4F' },
        'Re-Quote': { icon: 'retweet', color: '#FF9E3D' },
        'Win Back': { icon: 'rollback', color: '#FF9E3D' },
        'Event Call': { icon: 'calendar', color: '#FF9E3D' },
        'phone_appointments': { icon: 'phone', color: '#52C41A' },
        'office_appointments': { icon: 'schedule', color: '#1890FF' },
        'virtual_appointments': { icon: 'desktop', color: '#13C2C2' },
        'total_call_attempts': { icon: 'appstore', color: '#FF7A45' },
        'total_call_backs': { icon: 'rollback', color: '#FF9E3D' },
        'queued_files': { icon: 'clock-circle' },
        'external_rac_files_count': { icon: 'export', color: '#1f14faff' },
        'rs_queued_count': { icon: 'clock-circle', color: '#FAAD14' },
        'opportunity_queued_files': { icon: 'clock-circle', color: '#FAAD14' },
        'lead_queued_files': { icon: 'clock-circle', color: '#026704ff' },
    };


    useEffect(() => {
        if (visible && effectiveUserData) {
            fetchStats();
        }
    }, [visible, effectiveUserData]);


    const effectiveUserData = useMemo(() => {
        return userData || DEFAULT_USER_DATA;
    }, [userData, DEFAULT_USER_DATA]);




    const fetchStats = async () => {
        setLoading(true);
        const { id, data: cardsData, userType, start_date, end_date, name } = effectiveUserData;
        const uType = userType === EA ? BOBADMIN : userType;
        const isReviewAdmin = uType === REVIEWADMIN;

        const fallbackStartDate = RSFSCardFilters.datemodified.start_date;
        const fallbackEndDate = RSFSCardFilters.datemodified.end_date;

        const gridStartDate = RSFSFilters.datemodified.start_date;
        const gridEndDate = RSFSFilters.datemodified.end_date;

        const finalStartDate = gridStartDate || start_date || fallbackStartDate;
        const finalEndDate = gridEndDate || end_date || fallbackEndDate;
        const hideBadPhoneNumber = RSFSCardFilters.hideBadPhoneNumber === undefined
            ? true
            : Boolean(RSFSCardFilters.hideBadPhoneNumber);
        const badPhoneNumberParams = hideBadPhoneNumber ? { bad_phone_number_status: false } : {};

        try {
            const cardRaw = localStorage.getItem('card');
            const [res1, res2, res3, res4, res5] = await Promise.allSettled([
                axios.get(isReviewAdmin ? GET_RS_ADMIN_USER_STATS : GET_FS_ADMIN_USER_STATS, {
                    params: { user_id: id, start_date: finalStartDate, end_date: finalEndDate, user_type: uType, ...badPhoneNumberParams }
                }),
                axios.get(isReviewAdmin ? GET_RS_OTHER_STATISTICS_PIE : GET_SUB_TYPE_OF_CALL_STATS, {
                    params: { start_date: finalStartDate, end_date: finalEndDate, scheduler_specialist_id: id, ...badPhoneNumberParams }
                }),
                axios.get(isReviewAdmin ? GET_RS_OTHER_STATISTICS_PIE_1 : GET_FS_CALL_ACTION_STATS, {
                    params: { start_date: finalStartDate, end_date: finalEndDate, scheduler_specialist_id: id, ...badPhoneNumberParams }
                }),
                axios.get(isReviewAdmin ? GET_RS_APPOINTMENT_STATS : GET_FS_ADMIN_DASHBOARD_APPOINTMENT_STATS, {
                    params: { start_date: finalStartDate, end_date: finalEndDate, scheduler_specialist_id: id, ...badPhoneNumberParams }
                }),
                !isReviewAdmin
                    ? axios.get(GET_TYPE_OF_CALL_STATS, {
                        params: { start_date: finalStartDate, end_date: finalEndDate, scheduler_specialist_id: id, ...badPhoneNumberParams }
                    })
                    : Promise.resolve({ data: { data: {} } }),
            ]);

            const stats = {
                ...(res1.status === "fulfilled" ? res1.value.data : {}),
                ...(res2.status === "fulfilled" ? res2.value.data.data : {}),
                ...(res3.status === "fulfilled" ? res3.value.data.data : {}),
                ...(res4.status === "fulfilled" ? res4.value.data.data : {}),
                ...(!isReviewAdmin && res5.status === "fulfilled" ? res5.value.data.data : {})
            };

            const updated = cardsData.map(card => ({
                ...card,
                calls:
                    card.dashboard_stats === 'last_login'
                        ? (stats[card.dashboard_stats] ?
                            moment(stats[card.dashboard_stats]).format('HH:mm') : 'N/A')
                        : (stats[card.dashboard_stats] ? stats[card.dashboard_stats] : card.calls),
                start_date,
                end_date,
                user_id: id
            }));

            setCallCounts(updated);
        } catch (err) {
            console.error("Modal data fetch failed", err);
        } finally {
            setLoading(false);
        }
    };

    // if (!userData) return null;

    return (
        <Modal
            title={
                <div>
                    <div style={{ fontWeight: 600 }}>{effectiveUserData.name}</div>
                    <div style={{ fontSize: '12px' }} className="custom-text-dark">
                        {moment(RSFSFilters.datemodified.start_date || '2010-01-01').format("MM/DD/YYYY")} -
                        {moment(RSFSFilters.datemodified.end_date || '2050-01-01').format("MM/DD/YYYY")}
                    </div>
                </div>
            }
            visible={visible}
            onCancel={onClose}
            footer={null}
            centered
            width={800}
            // style={{ marginLeft: "10%" }}
            className="modal-stats "
        >
            <Spin spinning={loading}>
                <div className={`popup-card-container ${!loading ? 'loaded' : ''}`}
                    style={{ minHeight: '150px' }}
                >
                    {callCounts.map((item, idx) => (
                        <div key={idx}
                            className="popup-card hoverable-label"
                            role={item.isClickable ? "button" : undefined}
                            tabIndex={item.isClickable ? 0 : undefined}
                            onClick={() => item.isClickable && onCardClick(item, effectiveUserData.name)}
                            onKeyDown={(e) => {
                                if (item.isClickable && (e.key === 'Enter' || e.key === ' ')) {
                                    e.preventDefault();
                                    onCardClick(item, effectiveUserData.name);
                                }
                            }}
                            style={{ cursor: item.isClickable ? "pointer" : "default" }}
                            aria-label={item.isClickable ? `Click to view ${item.title || 'item'}` : undefined}
                        >
                            <Icon
                                type={iconMeta[item.dashboard_stats] ? iconMeta[item.dashboard_stats].icon : 'phone'}
                                style={{ color: iconMeta[item.dashboard_stats] ? iconMeta[item.dashboard_stats].color : 'gray' }}
                                className="dashboard-icon"
                            />

                            <span className="popup-card-title-style">{item.title}:</span>
                            <span className="popup-card-highlight-text"
                                style={{ textDecoration: item.isClickable ? "underline" : "none" }}
                            >
                                {item.calls}
                            </span>
                        </div>
                    ))}
                </div>
            </Spin>

        </Modal>
    );
};

export default UserStatsModal;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/review-admin/UserStatsModal.js